import React, { FC } from 'react'

import ConnectedExchangeShift from '../../../connectors/ConnectedExchangeShift/ConnectedExchangeShift'


const ExchangeShift: FC = () => (
    <ConnectedExchangeShift />
)

export default ExchangeShift
